// One place that redraws the screens, with the prototype's rule: never redraw a field someone is typing in.
type View = 'chrome' | 'todo' | 'overview' | 'alljobs' | 'calendar' | 'jobs' | 'admin';
const views = new Map<View, () => void>();

export function registerView(name: View, fn: () => void) {
  views.set(name, fn);
}

/** Redraw now. `only` limits it to some views (e.g. a filter change on one tab). */
export function render(only?: View[]) {
  for (const [name, fn] of views) {
    if (only && !only.includes(name)) continue;
    try { fn(); } catch (e) { console.error('render ' + name, e); }
  }
}

let deferred = false;

/** The field the person is in, if it's one we mustn't redraw under them. */
function editingField(): HTMLElement | null {
  const ae = document.activeElement as HTMLElement | null;
  if (!ae || !ae.closest) return null;
  if (!ae.closest('#list')) return null;
  if (!/^(TEXTAREA|INPUT|SELECT)$/.test(ae.tagName)) return null;
  if ((ae as HTMLInputElement).type === 'search') return null;
  return ae;
}

/**
 * Redraw after data changes. If someone is in a field on the Jobs tab, redraw everything else now
 * and the job cards once they leave the field.
 */
export function renderSoon() {
  const ae = editingField();
  if (!ae) { render(); return; }
  render(['chrome', 'todo', 'overview', 'alljobs', 'calendar', 'admin']);
  if (deferred) return;
  deferred = true;
  ae.addEventListener('blur', () => setTimeout(() => { deferred = false; render(); }, 0), { once: true });
}
